<template>
  <div id="app">
    <el-container>
      <el-header class="el-menu-demo1">
        <!-- <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        > -->
        
          <!-- <el-menu-item index=""><img src="./assets/img/天猫.png" alt/>天猫旗舰店</el-menu-item>
          <el-menu-item index="/T"><img src="./assets/img/q1688.png" alt/>1688店铺</el-menu-item>
          <el-menu-item index="/A168"><img src="./assets/img/b2b.png" alt/>B2B商城</el-menu-item> -->
          
        <!-- </el-menu> -->
      <!-- </el-header>
      <el-header class="el-menu-demo2"> -->
        <!-- <div class="logo">
          <img src="./assets/img/toplogo.png" alt />
        </div> -->
         <!-- <div class="logo1">
          <img src="./assets/img/军裕logo.jpg" alt />
        </div> -->
         
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
        
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/news">公司简介</el-menu-item>
          <el-menu-item index="/product">APP介绍</el-menu-item>
          <!-- <el-menu-item index="/case">数字中心</el-menu-item> -->
          <el-menu-item index="/goin">联系我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <p></p>
        </div>
        <div class="copyright">
          <span>江苏辛巴达食品有限公司  联系电话: 0312-66666 </span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-menu-demo2 {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;

  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
  .logo1 {
    width: 70px;
    padding: 0px;
    img {
      width: 100%;
      line-height: 60px;
      
    }
  }
}
.el-menu-demo1{
   display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%; 
  height: 40px; 
  margin: 0 auto;
  .el-menu{
    padding-left: 800px;
    border-bottom-color:#ffffff!important;
   .el-menu-item{
    border-bottom-color:#ffffff!important;
    font-size: 16px;
 
}

  
    
  }
  
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    text-align: center;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
